
export const TrainingRequest = {
    path: '/training_requests',
    name: 'training_requests',
    component: () => import('@/views/Training/TrainingRequest/TrainingRequestPage.vue'),
    children: [
        {
            path: '/training_requests/add',
            name: 'training_requests.add',
            component: () => import('@/views/Training/TrainingRequest/Form/TrainingRequestForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/training_requests/edit/:id',
            name: 'training_requests.edit',
            component: () => import('@/views/Training/TrainingRequest/Form/TrainingRequestForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/training_requests/delete/:id',
            name: 'training_requests.delete',
            component: () => import('@/views/Training/TrainingRequest/Form/TrainingRequestForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/training_requests/view/:id',
            name: 'training_requests.view',
            component: () => import('@/views/Training/TrainingRequest/Form/TrainingRequestForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/training_requests/timelines/:id/:module',
            name: 'training_requests.timelines',
            component: () => import('@/views/Request/Components/ValidationTimelines.vue'),
        },
        {
            path: '/training_requests/documents/:id',
            name: 'training_requests.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "TRAINING_REQUEST"}
        },
    ],
}

export const TrainingRequestConfiguration = {
    path: '/training_requests_configuration',
    name: 'training_requests_configuration',
    component: () => import('@/views/Training/TrainingRequest/Form/TrainingRequestConfiguration.vue'),
}